import { useNavigate } from "react-router-dom";
import { Trash2, Minus, Plus, ShoppingBag, ArrowRight } from "lucide-react";
import { useCart } from "../context/CartContext";
import { formatMXN } from "../lib/format";

export default function CartPage() {
  const { items, updateQty, removeItem, subtotal } = useCart();
  const navigate = useNavigate();

  if (items.length === 0)
    return (
      <div className="mx-auto max-w-3xl px-6 py-28 text-center">
        <ShoppingBag className="mx-auto mb-4 h-16 w-16 text-slate-300" />
        <h1 className="font-display text-2xl font-bold text-brand-navy">Tu carrito está vacío</h1>
        <p className="mt-2 text-slate-500">Descubre nuestras certificaciones de competencia laboral.</p>
        <button onClick={() => navigate("/")} className="mt-6 rounded-full brand-navy px-6 py-3 text-sm font-bold text-white">
          Ver catálogo
        </button>
      </div>
    );

  return (
    <div className="mx-auto max-w-6xl px-6 py-12">
      <h1 className="font-display text-3xl font-extrabold text-brand-navy">Carrito de compras</h1>
      <div className="mt-8 grid gap-8 lg:grid-cols-[1.6fr_1fr]">
        <div className="space-y-4">
          {items.map((item) => (
            <div key={item.product_id} data-testid={`cart-item-${item.product_id}`} className="flex gap-4 rounded-2xl border border-slate-200 bg-white p-4">
              <img src={item.image} alt={item.title} className="h-24 w-24 flex-none rounded-xl object-cover" />
              <div className="flex min-w-0 flex-1 flex-col">
                <p className="font-display font-bold text-brand-navy">{item.title}</p>
                <p className="text-brand-forest font-bold">{formatMXN(item.price)}</p>
                <div className="mt-auto flex items-center gap-2">
                  <button onClick={() => updateQty(item.product_id, item.quantity - 1)} className="rounded-md border border-slate-200 p-1.5">
                    <Minus className="h-4 w-4" />
                  </button>
                  <span className="w-8 text-center font-semibold">{item.quantity}</span>
                  <button onClick={() => updateQty(item.product_id, item.quantity + 1)} className="rounded-md border border-slate-200 p-1.5">
                    <Plus className="h-4 w-4" />
                  </button>
                  <button onClick={() => removeItem(item.product_id)} className="ml-auto flex items-center gap-1 text-sm text-slate-400 hover:text-rose-500">
                    <Trash2 className="h-4 w-4" /> Eliminar
                  </button>
                </div>
              </div>
            </div>
          ))}
        </div>

        <div className="lg:sticky lg:top-24 lg:self-start">
          <div className="rounded-2xl border border-slate-200 bg-white p-6 shadow-lg">
            <h2 className="font-display text-lg font-bold text-brand-navy">Resumen del pedido</h2>
            <div className="mt-4 space-y-2 text-sm text-slate-600">
              <div className="flex justify-between"><span>Subtotal</span><span>{formatMXN(subtotal)}</span></div>
              <div className="flex justify-between text-slate-400"><span>IVA</span><span>Incluido</span></div>
            </div>
            <div className="mt-4 flex justify-between border-t border-slate-100 pt-4">
              <span className="font-semibold text-brand-navy">Total</span>
              <span data-testid="cart-total-amount" className="font-display text-2xl font-extrabold text-brand-navy">{formatMXN(subtotal)}</span>
            </div>
            <button
              data-testid="cart-page-checkout-button"
              onClick={() => navigate("/checkout")}
              className="mt-6 flex w-full items-center justify-center gap-2 rounded-xl brand-navy py-3.5 text-sm font-bold text-white transition-transform hover:scale-[1.02]"
            >
              Proceder al pago <ArrowRight className="h-4 w-4" />
            </button>
          </div>
        </div>
      </div>
    </div>
  );
}
